module.exports = __webpack_public_path__ + "img/login.40310f67.svg";